module.exports = __webpack_public_path__ + "img/landing.6ee7ae73.webp";